import styled from "styled-components";
import secondGift from "./SecondGift.png"

const SecondGift = styled.img`
width: 288px;
height: 128px;
  flex-grow: 0;
  object-fit: contain;

    `

export default () => (
    <SecondGift src={secondGift} alt={"두번째 선물"}/>
)


